// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width: 800px){.user-info{margin-top:40px}}\n", "",{"version":3,"sources":["/home/casey/quavertrack/frontend/src/pages/UserInfo.scss"],"names":[],"mappings":"AAAA,0CACE,WACE,eAAgB,CACjB","file":"UserInfo.scss","sourcesContent":["@media only screen and (max-width: 800px) {\n  .user-info {\n    margin-top: 40px;\n  }\n}\n"]}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
